import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Box,
    Typography,
    Snackbar,
    Grid,
    Alert,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { quantum, trio } from 'ldrs';
import ExpensesTable from './Tables/ExpensesTable';
import { styled, keyframes } from '@mui/system';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import { ListPlus } from 'lucide-react';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Notyf } from 'notyf';


const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

quantum.register();
trio.register();

const AddExpenses = () => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [subExpenses, setSubExpenses] = useState([{ subexpense: '' }]);
    const [expenses, setExpenses] = useState('');
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false); // State for Snackbar visibility
    const [snackbarMessage, setSnackbarMessage] = useState(''); // State for Snackbar message
    const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // State for Snackbar severity
    const navigate = useNavigate();
    const notyf = new Notyf({
        position: { x: 'left', y: 'bottom' },
        duration: 3000,
      });
      
      
    const handleSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };


    {/**useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);
    
    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return; // Exit if no token
    
            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };
    
        fetchProfile();
    }, [token]);*/}

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/"); // Redirect on 401 error
                }
            }
        };

        fetchProfile();
    }, []);

    const handleSubExpenseChange = (index, key, value) => {
        const newSubExpenses = [...subExpenses];
        newSubExpenses[index][key] = value;
        setSubExpenses(newSubExpenses);
    };

    const addSubExpense = () => setSubExpenses([...subExpenses, { subexpense: '' }]);

    const removeSubExpense = (index) => {
        const newSubExpenses = subExpenses.filter((_, i) => i !== index);
        setSubExpenses(newSubExpenses);
    };

    const handleSubmit = async () => {
        setLoading(true); // Start loading

        const hasInvalidCategory = !expenses;

        if (hasInvalidCategory) {
            //handleSnackbar('Please enter the expenses category.', 'error');
            notyf.error('Expenses category is required');
            setLoading(false);
            return;
        }

        try {
            const data = {
                usertoken: user.id,
                expenses,
                subexpenses: subExpenses.map(subExpense => ({
                    subexpense: subExpense.subexpense
                })),
            };

            const response = await axios.post('https://admin.bizstor.lk/public/api/save-expenses-category-data', data);

            setExpenses('');
            setSubExpenses([{ subexpense: '' }]);
            //handleSnackbar('Expenses added successfully!', 'success');
            notyf.success('Expenses added successfully!');
            setLoading(false); // Stop loading

        } catch (error) {
            //console.error('Error saving data:', error);
            notyf.error('Something went wrong!');
        } finally {
            setLoading(false); // Stop loading
        }
    };


    return (
        <Box sx={{mt:10}}>
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 }, // Adjust margins for responsiveness
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' }, // Responsive font size
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Add - Expenses
                    </Typography>
                </Box>
            </AnimatedTypography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative'
                }}
            >
                <Typography variant="h5">

                </Typography>
                
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center', 
                        '@media (max-width: 600px)': {
                            margin: 'auto',
                        },
                        color: '#1e293b',
                        ml: 2
                    }}
                >
                    <h2>Add Expenses</h2>
                </Box>
                <Box
                    sx={{
                        m: 2
                    }}
                >

                    <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
                        <Grid item xs={12} sm={4}>
                            {/**<TextField
                                label="Expenses Category"
                                value={expenses}
                                onChange={(e) => setExpenses(e.target.value)}
                                variant="outlined"
                                fullWidth
                                size="small"
                            />*/}
                            <FormControl variant="outlined" fullWidth size="small">
                                <InputLabel>Expenses Category</InputLabel>
                                <Select
                                    value={expenses}
                                    onChange={(e) => setExpenses(e.target.value)}
                                    label="Expenses Category"
                                    fullWidth
                                >
                                    <MenuItem value="cost of sales">Cost Of Sales</MenuItem>
                                    <MenuItem value="expenses">Expenses</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                </Box>

                <Box
                    sx={{
                        m: 2
                    }}
                >
                    {/**<Box
                        sx={{
                            mb: 2
                        }}
                    >
                        <Button variant="outlined" onClick={addSubExpense}>
                        <ListPlus />
                        </Button>
                    </Box>*/}
                    <Box style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '15px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={addSubExpense}
                            style={{ backgroundColor: 'black', color: 'white' }}
                        >
                            <PlaylistAddIcon />
                        </Button>
                    </Box>
                    {subExpenses.map((subExpense, index) => (
                        <Grid container spacing={2} key={index} mb={2}>
                            <Grid item xs={10} sm={4}>
                                <TextField
                                    label={`Sub expense ${index + 1}`}
                                    value={subExpense.subexpense}
                                    onChange={(e) => handleSubExpenseChange(index, 'subexpense', e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={2} sm={2}>
                                <IconButton variant="outlined" onClick={() => removeSubExpense(index)}
                                    size="small"
                                    color='inherit'
                                    sx={{
                                        '&:hover': {
                                            color: 'red',
                                        },
                                    }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    ))}

                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '10px',
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        style={{
                            backgroundColor: '#4287f5',
                            color: 'white',
                            marginTop: '30px',
                            borderRadius: '20px',
                            padding: '8px 24px',
                            '&:hover': {
                                backgroundColor: '#356bc4',
                            },
                            marginBottom: { xs: '8px', sm: '0' }
                        }}                    >
                        Add Expenses
                    </Button>
                </Box>

                {loading && (
                    <Box sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'white',
                        zIndex: 9999
                    }}>
                        <l-trio
                            size="50"
                            speed="1.3"
                            color="red"
                        ></l-trio>
                    </Box>
                )}

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                        sx={{
                            width: '100%',

                        }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Box>
            <ExpensesTable />
        </Box>
    );
};

export default AddExpenses;
